<template>
  <v-container fluid class="pa-0 mo-bg" style="min-height: 87vh">
    <v-row align="center" justify="center" class="ma-0 pa-0">
      <v-col cols="12" sm="10" md="8" lg="7">
        <v-sheet
          class="mo-panel elevation-3 rounded-xl mx-auto"
          max-width="860"
        >
          <v-toolbar flat dense class="mo-toolbar">
            <v-toolbar-title class="white--text d-flex align-center">
              <v-icon left color="white" class="mr-2"
                >mdi-clipboard-text-outline</v-icon
              >
              MO With Printed Passet
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <div class="position-relative">
            <canvas ref="bgCanvas" class="bg-canvas"></canvas>
            <div class="pa-5 pt-6 px-6 px-sm-8">
              <!-- Header info (subset of MO detail) -->
              <v-row dense>
                <v-col cols="12">
                  <div class="label with-icon">
                    <v-icon small class="label-icon">mdi-pound-box</v-icon>
                    <span>Nomor MO</span>
                  </div>
                  <div class="value emphasis-1">
                    {{ (header && header.mo_number) || '-' }}
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="label with-icon">
                    <v-icon small class="label-icon">mdi-barcode</v-icon>
                    <span>Nomor Kode Produksi</span>
                  </div>
                  <div class="value emphasis-2">
                    {{ (header && header.lot_number) || '-' }}
                  </div>
                </v-col>

                <v-col cols="6" md="6">
                  <div class="label with-icon">
                    <v-icon small class="label-icon">mdi-tag-outline</v-icon>
                    <span>Kode Produk</span>
                  </div>
                  <div class="value">
                    {{ (header && header.product_code) || '-' }}
                  </div>
                </v-col>
                <v-col cols="6" md="6">
                  <div class="label with-icon">
                    <v-icon small class="label-icon"
                      >mdi-package-variant</v-icon
                    >
                    <span>Nama Produk</span>
                  </div>
                  <div class="value uppercase">
                    {{ (header && header.product_name) || '-' }}
                  </div>
                </v-col>
              </v-row>

              <!-- Search -->
              <v-row dense class="mt-3">
                <v-col cols="12">
                  <v-text-field
                    class="neo-input search-input rounded-xl"
                    v-model="searchQuery"
                    placeholder="Search"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    outlined
                    dense
                  />
                </v-col>
              </v-row>

              <!-- Printed forms list -->
              <v-row dense>
                <v-col cols="12" v-if="filteredForms.length === 0">
                  <div class="text-center grey--text">Tidak ada data</div>
                </v-col>
                <v-col cols="12" v-for="(row, idx) in filteredForms" :key="idx">
                  <v-card
                    class="passet-card rounded-lg elevation-1"
                    :class="
                      row.status === 'success'
                        ? 'ok'
                        : row.status === 'warning'
                        ? 'warn'
                        : 'bad'
                    "
                  >
                    <v-card-text class="py-3">
                      <div class="d-flex align-center justify-space-between">
                        <div class="code">{{ row.code }}</div>
                        <div class="d-flex align-center">
                          <v-icon small class="mr-4">mdi-printer</v-icon>
                          <v-icon
                            small
                            :class="
                              row.status === 'success'
                                ? 'ok-icon'
                                : row.status === 'warning'
                                ? 'warn-icon'
                                : 'bad-icon'
                            "
                          >
                            {{
                              row.status === 'success'
                                ? 'mdi-check-bold'
                                : row.status === 'warning'
                                ? 'mdi-alert'
                                : 'mdi-close-thick'
                            }}
                          </v-icon>
                        </div>
                      </div>
                      <div class="meta mt-1">
                        Printed at : {{ row.printed_at }}
                      </div>
                      <div class="meta">Count : {{ row.count }}</div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// import axios from 'axios'
export default {
  name: 'MoWithPrintedPasset',
  data: function () {
    return {
      header: null,
      searchQuery: '',
      forms: []
    }
  },
  computed: {
    filteredForms: function () {
      var q = (this.searchQuery || '').toString().toLowerCase()
      if (!q) return this.forms
      return this.forms.filter(function (x) {
        var s1 = (x.code || '').toString().toLowerCase()
        var s2 = (x.printed_at || '').toString().toLowerCase()
        return s1.indexOf(q) !== -1 || s2.indexOf(q) !== -1
      })
    }
  },
  mounted: function () {
    var self = this
    this.$nextTick(function () {
      self.drawBackground()
      window.addEventListener('resize', self.drawBackground)
    })
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.drawBackground)
  },
  methods: {
    drawBackground: function () {
      var canvas = this.$refs.bgCanvas
      if (!canvas) return
      var container = canvas.parentElement
      var w = container.clientWidth
      var h = 200
      if (w < 600) h = 150
      canvas.width = w
      canvas.height = h
      var ctx = canvas.getContext('2d')
      ctx.clearRect(0, 0, w, h)

      // soft blobs following palette
      var g1 = ctx.createRadialGradient(
        w * 0.25,
        h * 0.5,
        10,
        w * 0.25,
        h * 0.5,
        160
      )
      g1.addColorStop(0, 'rgba(144, 202, 249, 0.35)')
      g1.addColorStop(1, 'rgba(144, 202, 249, 0)')
      ctx.fillStyle = g1
      ctx.beginPath()
      ctx.arc(w * 0.25, h * 0.5, 140, 0, Math.PI * 2)
      ctx.fill()

      var g2 = ctx.createRadialGradient(
        w * 0.8,
        h * 0.2,
        10,
        w * 0.8,
        h * 0.2,
        140
      )
      g2.addColorStop(0, 'rgba(165, 214, 167, 0.35)')
      g2.addColorStop(1, 'rgba(165, 214, 167, 0)')
      ctx.fillStyle = g2
      ctx.beginPath()
      ctx.arc(w * 0.8, h * 0.2, 130, 0, Math.PI * 2)
      ctx.fill()
    }
  }
}
</script>

<style scoped>
.neo-surface {
  --bg: #f3f6fb;
  background: var(--bg) !important;
}
.neo-input /deep/ .v-input__slot,
.neo-input >>> .v-input__slot {
  background: var(--bg);
  border-radius: 9999px !important;
  border: none !important;
  box-shadow: inset 3px 3px 6px rgba(0, 0, 0, 0.1),
    inset -3px -3px 6px rgba(255, 255, 255, 0.95) !important;
}
.neo-input /deep/ fieldset,
.neo-input >>> fieldset {
  border: 0 !important;
}
.neo-input /deep/ .v-text-field__details,
.neo-input >>> .v-text-field__details {
  display: none;
}
/* Background & panel styles (aligned with previous pages) */
.mo-bg {
  background: linear-gradient(180deg, #fafcff 0%, #ffffff 70%);
}
.mo-toolbar {
  background: linear-gradient(135deg, #90caf9 0%, #a5d6a7 100%);
}
.mo-panel {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
}
.bg-canvas {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 200px;
  pointer-events: none;
}

/* Labels and values */
.label {
  color: #6b7280;
  font-size: 0.85rem;
  margin-bottom: 2px;
}
.label.with-icon {
  display: flex;
  align-items: center;
}
.label-icon {
  margin-right: 6px;
  color: #64b5f6;
}
.value {
  color: #263238;
  font-size: 1rem;
}
.value.uppercase {
  text-transform: uppercase;
}
.value.emphasis-1 {
  font-size: 1.25rem;
  font-weight: 700;
}
.value.emphasis-2 {
  font-size: 1.15rem;
  font-weight: 600;
}

/* Search */
.search-input .v-input__slot {
  border-radius: 9999px !important;
}

/* List cards */
.passet-card {
  border: 1px solid rgba(0, 0, 0, 0.08);
}
.passet-card .code {
  font-weight: 800;
  font-size: 1.05rem;
}
.passet-card .meta {
  font-size: 0.9rem;
  color: #607d8b;
}
.passet-card.ok {
  border-left: 3px solid #81c784;
}
.passet-card.warn {
  border-left: 3px solid #ffb74d;
}
.passet-card.bad {
  border-left: 3px solid #e57373;
}
.ok-icon {
  color: #43a047 !important;
}
.warn-icon {
  color: #fb8c00 !important;
}
.bad-icon {
  color: #e53935 !important;
}

/* Responsive tweaks */
@media (max-width: 600px) {
  .bg-canvas {
    height: 150px;
  }
  .value.emphasis-1 {
    font-size: 1.15rem;
  }
  .value.emphasis-2 {
    font-size: 1.05rem;
  }
}
</style>
